import { type FunctionComponent } from 'react';
import { type ServerAnalyticsInterface } from '../../../../../../@types/build';
import { type AnalyticsEvent } from '../../../../helpers/analytics/analytics.helper';
import { MaybeStyledLink } from '../../../common-components/link/maybe-styled-link.component';

export type TitleProps = {
	url?: string;
	brandName: string;
	title: string;
	titleDisplay?: 'dn di-ns' | 'di';
	titleTruncation?: 'tc2-title' | 'tc3-title';
	fontSize?: 'f5' | 'f6';
	automationHook?: string;
	analyticsEvent?: AnalyticsEvent | AnalyticsEvent[];
	serverAnalytics?: ServerAnalyticsInterface;
	className?: string;
};

export const Title: FunctionComponent<TitleProps> = ({
	url,
	brandName,
	title,
	titleDisplay = 'di',
	titleTruncation = '',
	fontSize = 'f5',
	automationHook,
	analyticsEvent,
	serverAnalytics,
	className = ''
}) => {
	return (
		<MaybeStyledLink
			url={url}
			color="grey-darker"
			automationHook={automationHook}
			analyticsEvent={analyticsEvent}
			serverAnalytics={serverAnalytics}>
			<div className={`lh-title fw3 ${fontSize} ${titleTruncation} ${className}`} data-testid="product-title-container">
				<span className="fw6">{brandName}</span> <span className={titleDisplay}>{title}</span>
			</div>
		</MaybeStyledLink>
	);
};
